export default {
	ru: {
		advice: 'Рекомендуется выключить перевод страницы',
	},
};
